module.exports = __webpack_public_path__ + "img/icon-checklist.64cf10d4.png";